import {createAction} from '@reduxjs/toolkit';
import {
  type FeatureCollectionId,
  type FeatureRef,
} from '@src/types/featureCollections.ts';

const actionPrefix = 'FEATURE_COLLECTIONS';

export const selectCollectionFeatureRef = createAction<FeatureRef | null>(
  `${actionPrefix}/SELECT_COLLECTION_FEATURE_REF`,
);

export const setShowManageQuota = createAction<boolean>(
  `${actionPrefix}/SET_SHOW_MANAGE_QUOTA`,
);

export const setVisibleCollection = createAction<FeatureCollectionId | null>(
  `${actionPrefix}/SET_VISIBLE_COLLECTION`,
);
